import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
ActiveStorage.start()

import '../src/adlp'

$(function() {
  var footerHeight = $('#footer').outerHeight();
  $('#container').css('padding-bottom', footerHeight + 64);
});

$(function() {
  $('body').on('click', 'a[href^="#"]', function() {
    var href = $(this).attr('href');
    var target = href == '#' ? 'html' : href;
    var position = $(target).offset().top;

    $('html, body').animate({ scrollTop: position }, 500, 'swing');
    if ($(window).scrollTop() < position) {
      $('.scroll-btn').removeClass('hidden');
    } else {
      $('.scroll-btn').addClass('hidden');
    }
  });
});

$(function() {
  $('.brand-section-btn').on('click', function() {
    var target = $(this).data().target;
    $(target).find('.hidden-content').removeClass('hidden');
    $(this).addClass('hidden');
  });
});

$(function() {
  $('.expand-image-btn').on('click', function() {
    var target = $(this).data().target;
    $('.image-modal').removeClass('hidden');
    $(target).removeClass('hidden');

    $('body').css({
      position: 'fixed',
      top: $(window).scrollTop() * -1 + 'px',
      left: 0,
      right: 0
    });
  });

  $('.image-modal').on('click', function() {
    hideImageModal();
  });

  $('.image-modal-image').on('click', function(e) {
    e.stopPropagation();
  });

  $('.image-modal-close').on('click', function(e) {
    hideImageModal();
    e.stopPropagation();
  });

  function hideImageModal() {
    $('.image-modal').addClass('hidden');
    $('.expand-image').addClass('hidden');

    var scrollY = parseInt($('body').css('top')) * -1;
    $('body').removeAttr('style');
    $(window).scrollTop(scrollY);
  }
});

$(function() {
  $('.shop-btn').on('click', function() {
    var target = $(this).data().target;
    $(target).removeClass('hidden');
    $(target).find('.map-modal-inner').scrollTop(0);

    $(target).find('.shop-map').html($('<iframe>', {
      style: 'border: 0',
      allowfullscreen: true,
      src: $(this).data().addressSrc
    }));

    $(target).find('.shop-name').html($(this).data().name);
    $(target).find('.shop-address').html($(this).data().address);

    if ($(this).data().access) {
      $(target).find('.shop-access').closest('tr').removeClass('hidden');
      $(target).find('.shop-access').html($(this).data().access);
    } else {
      $(target).find('.shop-access').closest('tr').addClass('hidden');
      $(target).find('.shop-access').html('');
    }
    if ($(this).data().businessHour) {
      $(target).find('.shop-business-hour').closest('tr').removeClass('hidden');
      $(target).find('.shop-business-hour').html($(this).data().businessHour);
    } else {
      $(target).find('.shop-business-hour').closest('tr').addClass('hidden');
      $(target).find('.shop-business-hour').html('');
    }
    if ($(this).data().regularHoliday) {
      $(target).find('.shop-regular-holiday').closest('tr').removeClass('hidden');
      $(target).find('.shop-regular-holiday').html($(this).data().regularHoliday);
    } else {
      $(target).find('.shop-regular-holiday').closest('tr').addClass('hidden');
      $(target).find('.shop-regular-holiday').html('');
    }
     
    $('body').css({
      position: 'fixed',
      top: $(window).scrollTop() * -1 + 'px',
      left: 0,
      right: 0
    });
  });

  $('.map-modal').on('click', function(e) {
    hideMapModal();
  });

  $('.map-modal-body').on('click', function(e) {
    e.stopPropagation();
  });

  $('.map-modal-close').on('click', function(e) {
    hideMapModal();
    e.stopPropagation();
  });

  function hideMapModal() {
    $('.map-modal').addClass('hidden');

    var scrollY = parseInt($('body').css('top')) * -1;
    $('body').removeAttr('style');
    $(window).scrollTop(scrollY);
  }
});
